<template>
</template>

<script>
import {mapActions} from 'pinia'
import { useSharedListStore } from "../stores/sharedList"

export default {
  props: {
    name: {
      type: String,
      default: 'default'
    },
    items: {
      type: [Array, Object],
      required: true
    },
  },

  methods: {
    ...mapActions(useSharedListStore, ['registerList']),
  },

  mounted() {
    this.registerList(this.name, this.items);
  }
}
</script>
